import angular from 'angular';
import directive from './functions.directive';
import controller from './functions.controller';
import _function from './function';


export default angular.module('app.components.advisory.enterpriseModeling.functions', [
  _function
])
  .directive('emFunctions', directive)
  .controller('FunctionsController', controller)
  .name;

console.log('app.components.advisory.enterpriseModeling.functions created');
